import { getApolloClient } from 'owa-apollo';
import {
    DeleteCalendarDocument,
    DeleteCalendarMutation,
    DeleteCalendarMutationVariables,
} from '../graphql/__generated__/deleteCalendarMutation.interface';
import { CalendarId } from 'owa-calendar-cache';

type DeleteCalendarResult = DeleteCalendarMutation['deleteCalendar'];

/**
 * Invoke the delete calendar mutation
 * @param input input parameters for the mutation
 */
export const invokeDeleteCalendarMutation = async function (
    calendarId: CalendarId,
    changeKey: string
): Promise<DeleteCalendarResult> {
    const deleteCalendarMutationInput: DeleteCalendarMutationVariables = {
        calendarId: {
            itemId: { Id: calendarId.id },
            mailboxInfo: calendarId.mailboxInfo,
        },
        changeKey: changeKey,
    };

    const client = await getApolloClient();
    const result = await client.mutate({
        variables: deleteCalendarMutationInput,
        mutation: DeleteCalendarDocument,
    });

    return result?.data?.deleteCalendar;
};

export default invokeDeleteCalendarMutation;
